module.exports = __webpack_public_path__ + "img/1168.56ef52d3.gif";